import React, { PropsWithChildren, ReactElement } from 'react';

import { Loader } from '../loader';

const Suspense = ({ children }: PropsWithChildren<unknown>): ReactElement => {
  return <React.Suspense fallback={<Loader />}>{children}</React.Suspense>;
};

export { Suspense };
